export const generateCode = (range: number = 1e8) => Math.floor(range+Math.random()*range).toString(32);
